import React from 'react';

const Heart = () => {

    return (
        <span className="heart-emoji" role="img" aria-label="Heart">❤️</span> 
    )
}

export default Heart;
